export const REGION_GLOBAL = "Global";
export const REGION_APAC = "APAC";
export const REGION_EU = "EU";
export const REGION_MEA = "MEA";
export const REGION_NCSA = "NCSA";
export const REGIONS = [
  REGION_GLOBAL,
  REGION_APAC,
  REGION_EU,
  REGION_MEA,
  REGION_NCSA,
] as const;

export type Region = (typeof REGIONS)[number];
export function isRegion(value: string | undefined): value is Region {
  return REGIONS.includes(value as Region);
}
